import React from "react";
import Calculator from "./components/Calculator";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "./style.css";

const App = (props) => {
    const theme = createTheme({
        palette: {
            primary: {
                main: props.primarycolor || "#1976d2",
            },
            secondary: {
                main: props.secondarycolor || "#dc004e",
            },
            tertiary: {
                main: props.tertiarycolor || "#ff0000",
            },
        },
        typography: {
            fontFamily: props.font || "Roboto, sans-serif",
        },
    });
  	return (
        <ThemeProvider theme={theme}>
            <div id="react-wp-app">
                <Calculator {...props} />
            </div>
        </ThemeProvider>
  	);
};

export default App;